import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        py: { xs: 4, md: 8 },
        px: 2
      }}
    >
      <Paper
        sx={{
          maxWidth: 520,
          width: '100%',
          p: { xs: 3, md: 4 },
          background: 'var(--color-bg-alt)',
          border: '1px solid var(--color-border)',
          borderRadius: '12px',
          textAlign: 'center'
        }}
      >
        <Typography
          variant="h5"
          sx={{ color: 'var(--color-accent)', fontWeight: 700, mb: 1.5 }}
        >
          You don't have access to this page
        </Typography>
        <Typography sx={{ color: 'var(--color-text-secondary)', mb: 3 }}>
          This page is not assigned to your account. Contact your administrator if you need access.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/', { replace: true })}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            background: 'linear-gradient(135deg, var(--color-accent), var(--color-accent2))'
          }}
        >
          Go to Home
        </Button>
      </Paper>
    </Box>
  );
};

export default AccessDeniedPage;
